let PackagesItem = [
    {
        trackJunior: true,
        trackTitle: "Free Trial Package",
        trackSubtitle: true,
        trackPrice: "0",
        runningString: true,
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticketfree/1665496112630x112140478075633660',
    },
    {
        trackFull: true,
        trackTitle: "FULL ACCESS 🔥",
        trackSubtitle: "ticket",
        runningString: true,
        trackPrice: "179",
        earlyBird: "early birds price",
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Junior and Senior Track Access',
        trackLink: 'https://geekle.us/ticket/1665496290453x308803696710647800',
    },
    {
        trackTitle: "YEAR OF IOS ❤️",
        trackSubtitle: "package",
        runningString: true,
        trackPrice: "229",
        earlyBird: "one year access",
        trackDesc: "1",
        trackText: true,
        yearTrackText: true,
        trackText1: "One Year Package",
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticket/1695906375551x366693293920092160',
    },
    {
        newPremium: true,
        trackTitle: "GEEKLE PREMIUM",
        trackSubtitle: "MEMBERSHIP",
        trackPriceApperance: 2,
        trackPrice: "399",
        trackText: true,
        trackText1: "One Year Premium Membership",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://buy.stripe.com/00g8A760U4V98ak8wI',
        inverseColors: true,
    },
    {
        trackTitle: "TEAM-5",
        trackSubtitle: "YEAR GROUP PACKAGE",
        trackPriceApperance: 3,
        runningString: true,
        trackPrice: "999",
        trackText: true,
        trackText1: "One Year Pass for 5 team members",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://geekle.us/ticket/1694109810106x843614570263085000',
    },
    {
        trackTitle: "UNLIMITED",
        trackSubtitle: "YEAR ENTERPRISE PACKAGE",
        trackPriceApperance: 3,
        runningString: true,
        trackPrice: "5999",
        trackText: true,
        trackText1: "One Year Pass for up to 100 members",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://geekle.us/ticket/1694110751248x285686019182297100',
        validDate: '9.06',
    },
];

export default PackagesItem;
